import React, { useEffect, useState, useContext, useRef } from 'react'; /*st48236 - 508 compliance*/
import { Accordion } from "react-bootstrap";
import { LanguageContext } from "../contexts/LanguageContext";
import DOMPurify from 'dompurify';
import parse from 'html-react-parser';

const Faq = () => {

    const { pageContent } = useContext(LanguageContext);
    const [faqContent, setFaqContent] = useState([]);
    const liveContentRef = useRef(null); // Reference for the live region /*st48236 - 508 compliance*/
    const [isContentReady, setContentReady] = useState(false); // st48236 - 508 compliance Track when all API responses are received
    const [apiCallsCompleted, setApiCallsCompleted] = useState(false); // st48236 - 508 compliance Track when all API calls are completed

    useEffect(() => {

        if (pageContent?.faq) {
            setFaqContent(pageContent.faq);
            setApiCallsCompleted(true); // st48236 - 508 compliance Mark API calls as completed           
        }
    }, [pageContent]);

    const faqItems = [
        {
            question: faqContent?.faq_question1,
            answer: faqContent?.faq_answer1
        },
        {
            question: faqContent?.faq_question2,
            answer: faqContent?.faq_answer2
        },
        {
            question: faqContent?.faq_question3,
            answer: faqContent?.faq_answer3
        },
        {
            question: faqContent?.faq_question4,
            answer: parse(DOMPurify.sanitize(faqContent?.faq_answer4))
        },
        {
            question: faqContent?.faq_question5,
            answer: faqContent?.faq_answer5
        },
        {
            question: faqContent?.faq_question6,
            answer: faqContent?.faq_answer6
        }
    ];

    
    
        /*st48236 - 508 compliance*/
    const [userInteracted, setUserInteracted] = useState(false);
    
    useEffect(() => {
      const handleUserInteraction = () => {
        setUserInteracted(true);
      };
    
      // Listen for user interactions
      document.addEventListener('click', handleUserInteraction);
      document.addEventListener('keydown', handleUserInteraction);
      
      return () => {
        document.removeEventListener('click', handleUserInteraction);
        document.removeEventListener('keydown', handleUserInteraction);
      };
    }, []);
    
    useEffect(() => {
      let timeoutId;
      
      if (apiCallsCompleted && !isContentReady) {
        timeoutId = setTimeout(() => {
          setContentReady(true);
          
          // Only auto-focus if user hasn't interacted
          if (!userInteracted && liveContentRef.current) {
            requestAnimationFrame(() => {
              liveContentRef.current.focus({ preventScroll: true });
            });
          }
        }, parseInt(process.env.REACT_APP_READABILITY_TIMEOUT));
      }
      
      return () => {
        if (timeoutId) clearTimeout(timeoutId);
      };
    }, [apiCallsCompleted, isContentReady, userInteracted]);

    return (
        <main
            role="main"
            tabIndex="-1" // Make the <main> tag focusable
            ref={liveContentRef} // Attach the ref to the <main> tag
            style={{ outline: 'none' }} // revmove border
            aria-label="Frequently Asked Questions"
        > 
            <div className="container-fluid content-inner mt-n5 py-0">
                <div className="card">
                    <div className="bd-example px-3">
                        <div className="accordion py-4 mb-2 accordion-faq" id="accordionExample">
                            <Accordion defaultActiveKey={null} className="faqaccordian" flush>
                                {faqItems.map((item, index) => (
                                    <Accordion.Item key={index} eventKey={index.toString()} className="accordion-card faq-content">
                                        <Accordion.Header className="accordion-head gap-3">
                                            <div className="accordion-header-content">
                                                <h4 className={index === 0 ? 'me-2' : ''}>Q) {item.question}</h4>
                                            </div>
                                        </Accordion.Header>
                                        <Accordion.Body className="tablecard">
                                            <div tabIndex={0} className="accordion-body faq-body px-2">
                                                <div className="col-xl-12 px-1">
                                                    <p className='faqanswer'>{item.answer}</p>
                                                </div>
                                            </div>
                                        </Accordion.Body>
                                    </Accordion.Item>
                                ))}
                            </Accordion>
                        </div>
                    </div>
                </div>
            </div>
        </main> /*st48236 - 508 compliance*/
    );
};

export default Faq;